import React from 'react';
import ReactDOM from 'react-dom';
import './Common/styles/main.scss';
import App from './App/App';

ReactDOM.render(<App />, document.getElementById('root'));
